import { SwitchType } from './switch-type';
import { BitSwitchOperation } from './bit-switch-operation';
import { WordSwitchOperation } from './word-switch-operation';
import { SwitchState } from './switch-state';
import { OptionItem } from '../../utils/option-item';
import { FontSizeHelper } from '../../../shared/helpers/font-size-helper';
import { FontStyleHelper } from '../../../shared/helpers/font-style-helper';
import { TextAlignHelper } from '../../../shared/helpers/text-align-helper';
var SwitchHelper = /** @class */ (function () {
    function SwitchHelper() {
    }
    SwitchHelper.getSwitchTypes = function () {
        return SwitchHelper.switchTypes;
    };
    SwitchHelper.getSwitchOperations = function (switchType) {
        switch (switchType) {
            case SwitchType.Bit:
                return SwitchHelper.bitSwitchOperations;
            case SwitchType.Word:
                return SwitchHelper.wordSwitchOperations;
            default:
                return SwitchHelper.bitSwitchOperations;
        }
    };
    SwitchHelper.getDefaultSwitchSettings = function () {
        return SwitchHelper.getDefultBitSwitchSettings();
    };
    SwitchHelper.getDefultBitSwitchSettings = function () {
        return {
            type: SwitchType.Bit,
            settings: {
                operation: BitSwitchOperation.On,
                variableName: '',
                variableGroupName: '',
                dataSourceCode: 0
            }
        };
    };
    SwitchHelper.getDefaultWordSwitchSettings = function () {
        return {
            type: SwitchType.Word,
            settings: {
                operation: WordSwitchOperation.Add,
                operand: 1,
                variableName: '',
                variableGroupName: '',
                dataSourceCode: 0
            }
        };
    };
    SwitchHelper.getDefaultSwitchStates = function () {
        return [
            {
                id: SwitchState.Normal,
                text: SwitchHelper.getDefaultLabel()
            },
            {
                id: SwitchState.Pressed,
                text: SwitchHelper.getDefaultLabel()
            }
        ];
    };
    SwitchHelper.getDefaultSwitchSize = function () {
        return '64 32';
    };
    SwitchHelper.getDefaultLabel = function () {
        return {
            content: '',
            font: {
                isUnderline: false,
                fontSize: FontSizeHelper.defaultFontSize,
                fontStyle: FontStyleHelper.getDefaultFontStyle(),
                color: FontStyleHelper.defaultFontColor,
                textAlign: TextAlignHelper.AlignCenter
            }
        };
    };
    SwitchHelper.switchTypes = [
        new OptionItem(SwitchType.Bit, 'BitSet'),
        new OptionItem(SwitchType.Word, 'WordSet')
    ];
    SwitchHelper.bitSwitchOperations = [
        new OptionItem(BitSwitchOperation.On, 'On'),
        new OptionItem(BitSwitchOperation.Off, 'Off'),
        new OptionItem(BitSwitchOperation.Inverse, 'Inverse')
    ];
    SwitchHelper.wordSwitchOperations = [
        new OptionItem(WordSwitchOperation.Add, 'Add'),
        new OptionItem(WordSwitchOperation.Subtract, 'Subtract'),
        new OptionItem(WordSwitchOperation.SetConstant, 'SetConstant')
    ];
    return SwitchHelper;
}());
export { SwitchHelper };
